import { Flex, Text } from '@/_components';
import { FC } from 'react';
import type { InfoLabelProps } from './InfoLabel.types';

export const InfoLabel: FC<InfoLabelProps> = ({ label, info, children }) => {
  return (
    <Flex isColumn={true} gap={2} isFullWidth={true}>
      <Text type="tiny" fontWeight="bold" color="secondary">
        {label}
      </Text>
      {children}
      {info && <Text type="small">{info}</Text>}
    </Flex>
  );
};
